import { Box, Stack } from '@mui/material'
import Link from 'next/link'
import { ArrowLeftOMIcon } from '@omnea-app/icons'

export const SidebarBackLink = ({ href, label }: { href: string; label: string }) => (
  <Link href={href} passHref style={{ textDecoration: 'none', width: '100%' }}>
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{
        color: 'text.muted',
        ml: -2,
        py: 1,
        px: 6,
        '&:hover': {
          color: 'text.default',
        },
      }}
    >
      <ArrowLeftOMIcon size="14px" />
      <Box component="span" sx={{ typography: 'body-regular', fontWeight: 400 }}>
        {label}
      </Box>
    </Stack>
  </Link>
)
